import { Fragment, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import PrimaryButton from "../ui/buttons/primaryButton";
import Form from "../ui/forms";

import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Paper, Typography, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import {
  resetSpeakToAConsultantSuccess,
  sendSpeakToAConsultant,
} from "../../features/speakToAConsultant/speakToAConsultant.slice";
import { Report } from "../../libs/loggers";
import Input from "../ui/forms/fields/input";
import SpeakToAConsultantFeedback from "./SpeakToAConsultantFeedback";
import { resetSubmition } from "../../features/submition/submition.slice";
import { resetData } from "../../features/data/data.slice";
import { resetSteps } from "../../features/stepper.slice";
import { resetUser } from "../../features/user/user.slice";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    cursor: "pointer",
    minWidth: 320,
    maxWidth: 320,
    background: theme.palette.mode === "light" ? "#fff" : "#373434",
    textAlign: "center",
    marginBottom: "20px",
    marginRight: "20px",
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50px",
    position: "relative",
  },

  header: {
    fontWeight: "bold",
    marginTop: "30px",
    marginLeft: "30px",
    marginRight: "30px",
    fontSize: "14px",
  },
  cardMidSection: {
    minHeight: "142px",
  },
  icon: {
    width: "150px",
    marginRight: "16px",
    [theme.breakpoints.down("sm")]: {
      width: "60px",
    },
  },
  paper: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "900px",
    backgroundColor: theme.palette.mode === "light" ? "#F3F2F1" : "transparent",
    padding: "16px",
    borderRadius: "30px",
  },
}));

function HelpContactConsultantCard({ resetVehicle, requireHelp }) {
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const classes = useStyles();
  const theme = useTheme();

  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
  const userId = useSelector((state) => state.submition.data?.userId);
  const stepper = useSelector((state) => state.stepper.value);
  let page = window.location.pathname.replace(/^\/|\/$/g, "");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const success = useSelector(
    (state) => state.speakToAConsultant.speakToAConsultantSentSuccess
  );
  const loading = useSelector((state) => state.speakToAConsultant.loading);

  const [dialogOpen, setDialogOpen] = useState(false);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    surname: yup.string().required("Surname is required"),
    email: yup.string().required("Email is required"),
    phone: yup.string().required("Phone is required"),
    message: yup.string(),
  });

  const {
    control,
    handleSubmit,
    reset,
    register,
    watch,
    formState: { errors },
  } = useForm({
    mode: ["onBlur"],
    resolver: yupResolver(validationSchema),
  });

  const message = watch("message");

  const handleFeedBackClose = () => {
    setDialogOpen(false);
    reset();
    if (success) {
      navigate(stepper.steps[0].url);
      dispatch(resetSubmition());
      dispatch(resetData());
      dispatch(resetSteps());
      dispatch(resetUser());
    }
  };

  const handleClose = () => {
    const eventInfo = {
      action: "cancel",
      category: "help",
      description: `cancelled help speak to a consultant`,
      value: {
        currentPage: page,
        step: stepper.active + 1,
        value: `cancel_speak_to_a_consultant`,
      },
    };
    Report(eventInfo, userId, submitionId);
    setOpen(false);
  };

  const handleAction = () => {
    handleSubmit(onSubmit)();
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
    resetVehicle();
    reset();
  };

  const onSubmit = (data) => {
    const newData = { ...data, requireHelp: requireHelp };

    setAlertOpen(true);
    const eventInfo = {
      action: "submit",
      category: "help",
      description: "clicked submit on speak to a consultant dialog",
      value: {
        currentPage: page,
        step: stepper.active + 1,
        message: message,
        value: `speak_to_a_consultant`,
      },
    };
    Report(eventInfo, userId, submitionId);

    dispatch(sendSpeakToAConsultant(newData));
    setDialogOpen(true);
    setOpen(false);
  };

  const isLightMode = useMediaQuery("(prefers-color-scheme: light)");
  const mode = isLightMode ? "white" : "black";

  return (
    <Fragment>
      {/* <Card className={classes.card} onClick={handleClickOpen}>
        <Box className={classes.cardMidSection}>
          <img
            src={`https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/new_look_banners/stac_${mode}.png`}
            alt=""
            width="100%"
          />
        </Box>
        <Box className={classes.cardFooter}>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ pl: 2, pr: 2, mb: 2, position: "absolute", top: 0 }}
          >
            Contact Us
          </Typography>
        </Box>
      </Card> */}

      <Paper className={classes.paper}>
        <Box
          display={"flex"}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          <img
            src={`https://s3.af-south-1.amazonaws.com/s3.fairtree.public/invest+now+icons/Iconography_${mode}_Real+relationships.png`}
            alt="Vehicle Icon"
            className={classes.icon}
          />
          <Typography variant={"h3"} fontWeight={500}>
            Speak to a Consultant
          </Typography>
        </Box>
        <Form>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Please tell us how we can help you:
          </Typography>
          <Input
            {...register("message")}
            label="Type your message here..."
            multiline
            rows={3}
            error={!!errors.message}
            helperText={errors?.message?.message}
          />
          <br />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Please provide us with your:
          </Typography>
          <Input
            {...register("name")}
            label="Name"
            error={!!errors.name}
            helperText={errors?.name?.message}
          />
          <Input
            {...register("surname")}
            label="Surname"
            error={!!errors.surname}
            helperText={errors?.surname?.message}
          />
          <Input
            {...register("email")}
            label="Email"
            error={!!errors.email}
            helperText={errors?.email?.message}
          />
          <Input
            {...register("phone")}
            label="Phone"
            error={!!errors.phone}
            helperText={errors?.phone?.message}
          />
        </Form>
        <Box display={"flex"} justifyContent={"flex-end"} p={2}>
          <PrimaryButton
            sx={{ borderRadius: "30px" }}
            onClick={() => handleAction()}
          >
            Submit
          </PrimaryButton>
        </Box>
      </Paper>
      <Dialog fullWidth maxWidth={"lg"} open={open} onClose={handleClose}>
        <DialogTitle variant="h4">
          Speak To A Consultant
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: mobile ? 0 : 8,
              top: mobile ? 0 : 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Form>
            <Typography variant="h6" sx={{ mt: 2 }}>
              Please tell us how we can help you:
            </Typography>
            <Input
              {...register("message")}
              label="Type your message here..."
              multiline
              rows={3}
              error={!!errors.message}
              helperText={errors?.message?.message}
            />
            <br />
            <Typography variant="h6" sx={{ mt: 2 }}>
              Please provide us with your:
            </Typography>
            <Input
              {...register("name")}
              label="Name"
              error={!!errors.name}
              helperText={errors?.name?.message}
            />
            <Input
              {...register("surname")}
              label="Surname"
              error={!!errors.surname}
              helperText={errors?.surname?.message}
            />
            <Input
              {...register("email")}
              label="Email"
              error={!!errors.email}
              helperText={errors?.email?.message}
            />
            <Input
              {...register("phone")}
              label="Phone"
              error={!!errors.phone}
              helperText={errors?.phone?.message}
            />
          </Form>
        </DialogContent>
        <DialogActions>
          <PrimaryButton variant="outlined" onClick={handleClose}>
            Cancel
          </PrimaryButton>
          <PrimaryButton onClick={() => handleAction()}>Submit</PrimaryButton>
        </DialogActions>
      </Dialog>

      <SpeakToAConsultantFeedback
        open={dialogOpen} // LOCAL STATE
        onClose={handleFeedBackClose}
        loading={loading} // REDUX STATE
        success={success} // REDUX STATE
      />
    </Fragment>
  );
}

export default HelpContactConsultantCard;
